import React from "react";
import "./SavestTransaction.css";
import Tabs from "../SavestPay/Tabs";
import NoSavestTransaction from "../NoSavestTransaction";
// import TransactionCard from './Transactioncard';
// import Transactiondetails from './Transactiondetails'

const SavestTransaction = ({ transactions }) => {
  if (!transactions.length) {
    return <NoSavestTransaction />;
  }

  return (
    <div>
      <div className="transactionSession">
        <div className="transactionTitle">
          <p>Savest Transactions</p>
          {/* <span>View Earnings</span> */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Tabs transactions={transactions} />
          {/* <TransactionCard/> */}
        </div>
        {/* <Transactiondetails transactions={transactions} transaction /> */}
      </div>
    </div>
  );
};

export default SavestTransaction;
